import {useState} from 'react'; //, useEffect
import * as CoreFns from '../utilities/CoreFns';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import NormalBtn from '../StockItems/NormalBtn';
import TransferButton from './TransferButton';
import WagmiWrap from '../WagmiWrap';

import * as ConnectButton from '../ConnectButton';

import '@rainbow-me/rainbowkit/styles.css';
import {  useAccount, useNetwork } from 'wagmi';

function Main(props) {

  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var chains = props.chains;
  var getCredits = props.getCredits;
  var chainIdSelected = props.chainIdSelected;
  var setChainIdSelected = props.setChainIdSelected;
  var packageSelected = props.packageSelected;

  const [errorMsg, setErrorMsg] = useState(false);

  const {address} = useAccount()

  var opt1; 
  var opt2;

  var relevantChain = CoreFns.getRelevantChain(chainIdSelected, chains);

  const { chain } = useNetwork();
  var connectedChain = -1;
  if (chain){
    connectedChain = chain.id;
  }


    if (connectedChain === -1){
      opt1 = <ConnectButton.ConnectingButton />
    }else if (connectedChain !== chainIdSelected){
      opt1 = <ConnectButton.ConnectingButton />
      // <NormalBtn onClick={selectChain(relevantChain)} title='Change Chain'/>
    }else{
      var paymentOptions = [];
      if (chainIdSelected === 56){
        paymentOptions = [{t:'Binance-Peg BSC-USD', ad:'0x55d398326f99059fF775485246999027B3197955', dec:18},
            {t:'Binance-Peg BUSD Token', ad:'0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', dec:18}
          ]
      }else if (chainIdSelected === 137){
        paymentOptions = [
          {t:'USD Coin', ad:'0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', dec:6},
          {t:'Tether USD', ad:'0xc2132D05D31c914a87C6611C10748AEb04B58e8F', dec:6}
        ]
      }else if (chainIdSelected === 80001){
        paymentOptions = [{t:'USDT', ad:'0xbc44680b435Ee19DF43C6eA7eB73F61cd837f20c', dec:0}];
      }else if (chainIdSelected === 97){
        paymentOptions = [{t:'USDT', ad:'0x3E8A67Cb7470ca18e0Db866613a443EB2664Cf0F', dec:0}];
      }


      var paymentRows = paymentOptions.map((aCoin, index)=>{
            var packageSelectedX = packageSelected.anOption;
            var transferAmt = packageSelectedX.p; 

            function postPostFunction(response){
              if (response.t === 'atom' && response.v === 'succeeded'){
                getCredits();
                setErrorMsg({relevantChain, coinAddress:aCoin.ad, m:'Credits added!', isError:0});
                window.alert('Credits added!');
              }else{
                setErrorMsg({relevantChain, coinAddress:aCoin.ad, m:response.v, isError:1});
                window.alert(response.v);
              }
            }

           var actionPiece = <TransferButton address={aCoin.ad} amount={transferAmt} nosDec={aCoin.dec} chainId={chainIdSelected} coinName={aCoin.t} sessionID={sessionID} userID={userID} signKey={signKey} account={address} postPostFunction={postPostFunction}/>
            
            var errorSpan = null;
            if (errorMsg && errorMsg.relevantChain === chainIdSelected && errorMsg.coinAddress === aCoin.ad){
              var sssStyle1 = {};
              if (errorMsg.isError){
                sssStyle1.color = 'red';
              }
              errorSpan = <div style={sssStyle1}>{errorMsg.m}</div>
//
            }
//
           return (
                <tr key={index}>
                  <td>{aCoin.t}</td>
                  <td>{actionPiece}{errorSpan}</td>
                </tr>

            )

      });

      opt1 = <TableWrapRowsBoot rows={paymentRows} headerCells={['Coin', '']}/>
      opt2 = <p className='lead mb-0'>Please contact us on Telegram @cuessg if you would like to pay using other coins.<br/><br/></p>
//
    }
    function clickBackHere1(e){
      setChainIdSelected(0);
    }
    return <div>
          
          {opt1}
          {opt2}
          <NormalBtn onClick={clickBackHere1} title='Back'/>
      </div>
}


//
function App(props) {

  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var chainsIn = props.chains;
  var getCredits = props.getCredits;
  var chainIdSelected = props.chainIdSelected;
  var setChainIdSelected = props.setChainIdSelected;
  var packageSelected = props.packageSelected;
  var setPackageSelected = props.setPackageSelected;

  var inside = <Main userID={userID} sessionID={sessionID} signKey={signKey} chains={chainsIn} getCredits={getCredits} chainIdSelected={chainIdSelected} setChainIdSelected={setChainIdSelected} packageSelected={packageSelected} setPackageSelected={setPackageSelected}/>
  return <WagmiWrap inside={inside} currencyID={chainIdSelected} chains={chainsIn} />


}

export default App;
